document.addEventListener('DOMContentLoaded', () => {
    // 1. On cible notre conteneur de filtre
    const filterContainers = document.querySelectorAll('.agency-filter-ajax-container');
    
    // 2. On cible le bloc de boucle natif (Query Loop)
    const queryBlock = document.querySelector('.wp-block-query');

    if (!filterContainers.length || !queryBlock) return;

    filterContainers.forEach(container => {
        // On écoute les clics sur les liens <a> (les boutons natifs sont des <a>)
        container.addEventListener('click', async (e) => {
            const link = e.target.closest('a');
            
            // On vérifie si c'est un lien de filtre (contient ?agency_filter=)
            if (!link || !link.href.includes('filtre=')) return;

            e.preventDefault();

            // Gestion de l'état visuel (actif)
            container.querySelectorAll('.wp-block-button__link').forEach(btn => {
                btn.classList.remove('is-active-filter');
                btn.style.opacity = "1";
            });
            link.classList.add('is-active-filter');
            link.style.opacity = "0.7"; // Feedback visuel simple

            // Effet de chargement sur la boucle
            queryBlock.style.opacity = '0.4';
            queryBlock.style.transition = 'opacity 0.3s ease';

            try {
                const url = new URL(link.href);
                const response = await fetch(url.toString());
                const html = await response.text();
                
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newQuery = doc.querySelector('.wp-block-query');

                if (newQuery) {
                    queryBlock.innerHTML = newQuery.innerHTML;
                    // Mise à jour de l'URL sans recharger (optionnel)
                    window.history.pushState({}, '', url.toString());
                }
            } catch (err) {
                console.error("Erreur de filtrage :", err);
            } finally {
                queryBlock.style.opacity = '1';
            }
        });
    });
});